// var supplier_arry_tmp = [
//   {'key':'WS','label':'Winning Spirit','label1':'Winning Spirit','price':199,'cost':7.5},
//   {'key':'RM','label':'Ramo','label1':'Ramo','price':199,'cost':20},
//   {'key':'AS','label':'AS Colour','label1':'AS Colour','price':199,'cost':20},
//   {'key':'JB','label':'JBs Wear','label1':'JBs Wear','price':199,'cost':9.5},
//   {'key':'BIZ','label':'Fashion Biz','label1':'Fashion Biz','price':199,'cost':5.5},
//   {'key':'MAC','label':'Flexfit','label1':'Flexfit','price':199,'cost':20},
//   {'key':'GC','label':'Grace Collection','label1':'Grace Collection','price':199,'cost':20},
//   {'key':'PW','label':'Portwest','label1':'Portwest','price':199,'cost':10},
//   {'key':'AP','label':'Aussie Pacific','label1':'Aussie Pacific','price':199,'cost':55},  
//   {'key':'BIS','label':'Bisley','label1':'Bisley','price':199,'cost':0}, 
//   {'key':'JP','label':'Jet Pilot','label1':'Jet Pilot','price':199,'cost':0},
//   {'key':'HW','label':'Headwear','label1':'Headwear','price':199,'cost':20}  ,
//   {'key':'BAD','label':'Bad Workwear','label1':'Bad Workwear','price':199,'cost':20},  
//   {'key':'DNC','label':'DNC','label1':'DNC','price':199,'cost':20}  ,  
//   {'key':'ID','label':'Identitee','label1':'Identitee','price':199,'cost':20}  
// ];
var supplier_arry_tmp = [
  {'key':'WS','label':'Winning Spirit','label1':'Winning Spirit','price':0,'cost':7.5},
  {'key':'RM','label':'Ramo','label1':'Ramo','price':0,'cost':20},
  {'key':'AS','label':'AS Colour','label1':'AS Colour','price':0,'cost':20},
  {'key':'JB','label':'JBs Wear','label1':'JBs Wear','price':0,'cost':9.5},
  {'key':'BIZ','label':'Biz Collection','label1':'Fashion Biz','price':0,'cost':5.5},
  {'key':'MAC','label':'Flexfit','label1':'Flexfit','price':0,'cost':20},
  {'key':'GC','label':'Grace Collection','label1':'Grace Collection','price':0,'cost':20},
  {'key':'PW','label':'Portwest','label1':'Portwest','price':0,'cost':10},
  {'key':'AP','label':'Aussie Pacific','label1':'Aussie Pacific','price':0,'cost':55},  
  {'key':'BIS','label':'Bisley','label1':'Bisley','price':0,'cost':0}, 
  {'key':'JP','label':'Jet Pilot','label1':'Jet Pilot','price':0,'cost':0},
  {'key':'HW','label':'Headwear','label1':'Headwear','price':0,'cost':20}  ,
  {'key':'BAD','label':'Bad Workwear','label1':'Bad Workwear','price':0,'cost':20},  
  {'key':'DNC','label':'DNC','label1':'DNC','price':0,'cost':20}  ,  
  {'key':'ID','label':'Identitee','label1':'Identitee','price':0,'cost':20},  
  {'key':'JS','label':'JS','label1':'JS','price':0,'cost':20}  ,  
  {'key':'HY','label':'Hard Yakka','label1':'Hard Yakka','price':0,'cost':20}  ,  
  {'key':'KG','label':'King Gee','label1':'King Gee','price':0,'cost':20}  ,  
  {'key':'SYZ','label':'Syzmik','label1':'Syzmik','price':0,'cost':5.5}  ,  
  {'key':'GD','label':'Gildan Brands','label1':'Gildan Brands','price':0,'cost':25} ,
  {'key':'PS','label':'Puma Safety','label1':'Puma Safety','price':0,'cost':0}, // mykhailo
  {'key':'BS','label':'Buck Sports','label1':'Buck Sports','price':0,'cost':0},
  {'key':'NCCA','label':'Workcraft','label1':'NCC Apparel Pty Ltd','price':0,'cost':0}
];
export const  supplier_arry = supplier_arry_tmp.sort((a, b) => (a.label > b.label) ? 1 : -1)

export const supplier_short = {
  'WS':'Winning Spirit',
  'RM':'Ramo',
  'AS':'AS Colour',
  'JB':'JBs Wear',
  'BIZ':'Fashion Biz',
  'MAC':'Flexfit',
  'GC':'Grace Collection',
  'PW':'Portwest',
  'AP':'Aussie Pacific',
  'BIS':'Bisley',
  'JP':'Jet Pilot',
  'HW':'Headwear',
  'BAD':'Bad Workwear',
  'DNC':'DNC',
  'ID':'Identitee',
  'JS':'JS',
  'HY':'Hard Yakka',
  'KG':'King Gee',
  'SYZ':'Syzmik',
  'GD':'Gildan Brands',
  'PS':'Puma Safety', // mygkhailio
  'BS':'Buck Sports',
  'NCCA': 'NCC Apparel Pty Ltd',
};

// export const supplier_fee = {
//   'WS':{'price':199,'cost':20},
//   'RM':{'price':199,'cost':20},
//   'AS':{'price':199,'cost':20},
//   'JB':{'price':199,'cost':9.5},
//   'BIZ':{'price':199,'cost':5.5},
//   'MAC':{'price':199,'cost':20},
//   'GC':{'price':199,'cost':20},
//   'PW':{'price':199,'cost':10},
//   'AP':{'price':199,'cost':55},
//   'BIS':{'price':199,'cost':0},
//   'JP':{'price':199,'cost':20},
//   'HW':{'price':199,'cost':20},
//   'BAD':{'price':199,'cost':20},
//   'DNC':{'price':199,'cost':20},
//   'ID':{'price':199,'cost':20},
// };
//UPDATE `products` SET code=full_code WHERE `code` LIKE 'JS - %'
//SELECT * FROM `products` WHERE `code` LIKE 'JS%'

export const supplier_fee = {
  'WS':{'price':0,'cost':20}, //ok
  'RM':{'price':0,'cost':20}, //ok
  'AS':{'price':0,'cost':20}, //ok
  'JB':{'price':0,'cost':9.5}, //full_code to code
  'BIZ':{'price':0,'cost':5.5},//full_code to code
  'MAC':{'price':0,'cost':20},//ok
  'GC':{'price':0,'cost':20},//full_code to code
  'PW':{'price':0,'cost':10},//full_code to code
  'AP':{'price':0,'cost':55},//full_code to code
  'BIS':{'price':0,'cost':0},//full_code to code
  'JP':{'price':0,'cost':20},//full_code to code
  'HW':{'price':0,'cost':20},//full_code to code
  'BAD':{'price':0,'cost':20},//ok
  'DNC':{'price':0,'cost':20},//ok
  'ID':{'price':0,'cost':20},//ok
  'JS':{'price':0,'cost':20},//no
  'HY':{'price':0,'cost':20},//no
  'KG':{'price':0,'cost':20},//no
  'SYZ':{'price':0,'cost':5.5},//no
  'GD':{'price':0,'cost':25},//no
  'NCCA':{'price':0,'cost':0},
};

export const positionList = [
  "Breast Left",
  "Breast Right",
  "Front Centre",
  "Back Upper Neck",
  "Back Upper",
  "Sleeve Upper Right",
  "Sleeve Upper Left",
  "H'Wear Front Centre",
  "H'Wear Front Left",
  "H'Wear Front Right",
  "H'Wear Side Left",
  "H'Wear Side Right",
  "H'Wear Back Arch",
  "Other",
];

export const positionKeyList = [
  "BreastLeft",
  "BreastRight",
  "BackUpperNeck",
  "BackUpper",
  "SleeveUpperRight",
  "SleeveUpperLeft",
  "HwearFrontCentre",
  "HwearFrontLeft",
  "HwearFrontRight",
  "HwearSideLeft",
  "HwearSideRight",
  "HwearBackArch",
  "FrontCenter",
  "Other",
];

export default {
  // redirectUrl,
  // hostApi,
  // portApi,
  // baseURLApi,
  remote: "https://sing-generator-node.herokuapp.com",
  isBackend: true,
  auth: {
    email: '',//123
    password: ''//'rtang'
  },
}

export const brand_arry = [
  {'key':'Screen Print','label':'Screen Print 1C','admin_only':false},
  {'key':'Screen Print 2C','label':'Screen Print 2C','admin_only':true},
  {'key':'Embroidery','label':'Embroidery','admin_only':false},
  {'key':'Vinyl Print','label':'Vinyl Print','admin_only':true},
  {'key':'Digital Print','label':'Digital Print','admin_only':true},
  {'key':'Dye Sublimation','label':'Dye Sublimation','admin_only':true},
  {'key':'Custom Indent','label':'Custom Indent','admin_only':true},
  {'key':'Other','label':'Other','admin_only':true}  
];

export const setup_codes = [
  {'key':'None','label':'None'},
  {'key':'New Set Up','label':'New Set Up'},
  {'key':'Repeat Set Up','label':'Repeat Set Up'},
]


export const setup_color_change_options = [
  {'key':'None','label':'None'},
  {'key':'Colour Change','label':'Colour Change'},
]

export const film_codes = [
  {'key':'None','label':'None'},
  {'key':'5 x 5cm','label':'5 x 5cm'},
  {'key':'8 x 8cm','label':'8 x 8cm'},
  {'key':'12 x 12cm','label':'12 x 12cm'},
  {'key':'15 x 15cm','label':'15 x 15cm'},
  {'key':'15 x 20cm','label':'15 x 20cm'},
  {'key':'20 x 20cm','label':'20 x 20cm'},
  {'key':'20 x 28cm','label':'20 x 28cm'},
  {'key':'20 x 35cm','label':'20 x 35cm'},
  {'key':'25 x 35cm','label':'25 x 35cm'},
  {'key':'28 x 35cm','label':'28 x 35cm'},
]



export const film_costs_arry = {
  '5 x 5cm':{
    '25 - 49':0.6,
    '50 - 5000':0.5
  },
  '8 x 8cm':{
    '25 - 49':0.8,
    '50 - 5000':0.7
  },
  '12 x 12cm':{
    '25 - 49':1.2,
    '50 - 5000':1.1
  },
  '15 x 15cm':{
    '25 - 49':1.4,
    '50 - 5000':1.3
  },
  '15 x 20cm':{
    '25 - 49':1.6,
    '50 - 5000':1.4
  },
  '20 x 20cm':{
    '25 - 49':1.8,
    '50 - 5000':1.6
  },
  '20 x 28cm':{
    '25 - 49':2.1,
    '50 - 5000':1.9
  },
  '20 x 35cm':{
    '25 - 49':2.9,
    '50 - 5000':2.4
  },
  '25 x 35cm':{
    '25 - 49':3.4,
    '50 - 5000':2.9
  },
  '28 x 35cm':{
    '25 - 49':3.9,
    '50 - 5000':3.4
  }
}

export const setup_discounts = [
  {'key':'Volume Order','label':'Volume Order'},
  {'key':'Combined Volume Order','label':'Combined Volume Order'},
  {'key':"Director's Descretion",'label':"Director's Descretion"},
  {'key':"Repeat Order",'label':"Repeat Order"},
  {'key':"Loyalty Program",'label':"Loyalty Program"},
  {'key':"Volume Print",'label':"Volume Print"},
  {'key':"Volume Embroidery 50+",'label':"Volume Embroidery 50+"},
  {'key':"Volume Embroidery 100+",'label':"Volume Embroidery 100+"},
  {'key':"Volume Embroidery 200+",'label':"Volume Embroidery 200+"},
  {'key':"Other",'label':"Other"},
]
export const delivery_options = [
  {'key':'Couriers Please','label':'Couriers Please'},
  {'key':'KIS','label':'KIS'},
  {'key':'Other','label':'Other'},
]

export const task_options = [
  {'key':'Stock Check','label':'Stock Check'},
  {'key':'Design','label':'Design'},
  {'key':'Back Order','label':'Back Order'},
  {'key':'Billable Task','label':'Billable Task'},
  {'key':'Click & Collect','label':'Click & Collect'},
  {'key':'Contact Customer','label':'Contact Customer'},
  {'key':'Contact Supplier/Decorator/Subcontractor','label':'Contact Supplier/Decorator/Subcontractor'},
]

export const wfm_category_options = [
  "(x) Click 'n Collect",
  '(x) Design',
  '(x) DTF',
  '(x) Emb/Print/Vinyl',
  '(x) Embroid',
  '(x) Indent',
  '(x) Misc Product',
  '(x) Non Decorated Stock',
  '(x) Retail Order',
  '(x) Screen Print',
  '(x) Stickers',
  '(x) Vinyl Print',
  '(x) Wholesale Direct',
  '(z) Internal Project',
  '(z) Non Billable Task'
]